import React from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";

export const StyledInput = styled(Form.Control)`
  background-color: white !important;
  color: var(--input-font-color) !important;
  border: ${({ errorMessage, validateOnChange, borderColor }) =>
    errorMessage && validateOnChange
      ? "1px solid var(--danger) !important"
      : borderColor
      ? `1px solid ${borderColor} !important`
      : "1px solid #e0e0e0 !important"};
  border-radius: 5px !important;
  width: 100% !important;
  height: 40px;
  padding-inline-end: ${({ hasEndIcon }) => (hasEndIcon ? "2.5rem" : undefined)};
  transition: border-color 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    border-color: var(--main-color) !important;
  }

  &:focus {
    background-color: white !important;

    border: ${({ errorMessage, validateOnChange, borderColor }) =>
      errorMessage && validateOnChange
        ? "1px solid var(--danger) !important"
        : borderColor
        ? `1px solid ${borderColor} !important`
        : "1px solid var(--main-color) !important"};
    outline: 0;
    box-shadow: 0 0 0 3px rgba(28, 55, 65, 0.1) !important;
  }
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;

  .text-input-end-icon {
    position: absolute;
    inset-inline-end: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    color: var(--grey);
    cursor: pointer;
    font-size: 1.1rem;
    line-height: 1;
  }
`;

const TextInput = ({ fieldItem, validateOnChange }) => {
  const {
    id,
    name,
    textInputType,
    value,
    onChange,
    errorMessage,
    isDisabled,
    borderColor,
    placeholder,
    endIcon,
    onEndIconClick,
    maxLength,
  } = fieldItem;
  return (
    <InputWrapper>
      <StyledInput
        id={id}
        name={name}
        type={textInputType}
        value={value}
        onChange={onChange}
        errorMessage={errorMessage}
        validateOnChange={validateOnChange}
        disabled={isDisabled}
        borderColor={borderColor}
        placeholder={placeholder}
        maxLength={maxLength}
        hasEndIcon={!!endIcon}
      />
      {endIcon && (
        <button
          type="button"
          className="text-input-end-icon"
          onClick={onEndIconClick}
          tabIndex={-1}
        >
          {endIcon}
        </button>
      )}
    </InputWrapper>
  );
};

export default TextInput;
